import { create } from "zustand"
import type { DraftingError, ReviewRequest } from "@/types"

/**
 * draftingStore owns only error + review-gate state.
 * Stage progress is now managed by useOIOAgent (CopilotKit AG-UI state).
 */
interface DraftingState {
  error: DraftingError | null
  isAwaitingReview: boolean
  reviewData: ReviewRequest | null

  setError: (error: DraftingError) => void
  setAwaitingReview: (data: ReviewRequest | null) => void
  reset: () => void
}

const initialState = {
  error: null,
  isAwaitingReview: false,
  reviewData: null,
}

export const useDraftingStore = create<DraftingState>((set) => ({
  ...initialState,

  setError: (error) => set({ error }),

  setAwaitingReview: (data) =>
    set({ isAwaitingReview: data !== null, reviewData: data }),

  reset: () => set(initialState),
}))
